/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_External_Id_HintInputs */

const cs_settings_calendar_external_id_hint = /** @type {(inputs: Settings_Calendar_External_Id_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nechte prázdné pro primární kalendář. Vyplňte jen při synchronizaci vedlejšího kalendáře.`)
};

const en_settings_calendar_external_id_hint = /** @type {(inputs: Settings_Calendar_External_Id_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave empty for your primary calendar. Only needed if you sync a secondary calendar.`)
};

/**
* | output |
* | --- |
* | "Leave empty for your primary calendar. Only needed if you sync a secondary calendar." |
*
* @param {Settings_Calendar_External_Id_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_external_id_hint = /** @type {((inputs?: Settings_Calendar_External_Id_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_External_Id_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_external_id_hint(inputs)
	return cs_settings_calendar_external_id_hint(inputs)
});